import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classes from './WaiverWire.css';
import headerClasses from '../../components/FiltersHeader/filtersHeader.css';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Waiver Wire';
const FTN_WIDGET_URL = 'https://tools.ftnfantasy.com/huddle/waiver-wire/index.html';
const DEFAULT_HEIGHT = 315;
const LOGGED_OUT_HEIGHT = DEFAULT_HEIGHT / 2;

const mapStateToProps = state => ({
  loggedIn: state.auth.loggedIn,
});

export class WaiverWire extends PureComponent {
  static propTypes = {
    loggedIn: PT.bool.isRequired,
  };

  state = {
    height: DEFAULT_HEIGHT,
  };

  componentDidMount() {
    document.title = `${pageTitle} - TheHuddle`;
    gciPageView(pageTitle);
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = event => {
    const iframe = this.iframeRef;
    if (!this.props.loggedIn || !iframe || event.source !== iframe.contentWindow) return;
    if (event.data && event.data.type === 'resize' && typeof event.data.height === 'number') {
      this.setState({ height: event.data.height });
    }
  };

  render() {
    const height = this.props.loggedIn ? this.state.height : LOGGED_OUT_HEIGHT;

    return (
      <div className={classes.wrapper}>
        <div className={headerClasses.pageHeading}>
          <h1 className={headerClasses.heading}>{pageTitle}</h1>
        </div>
        <iframe
          ref={el => { this.iframeRef = el; }}
          title={pageTitle}
          src={FTN_WIDGET_URL}
          style={{ width: '100%', height: `${height}px`, border: 'none' }}
          scrolling="no"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(WaiverWire);



// WEBPACK FOOTER //
// ./src/app/views/WaiverWire/WaiverWire.js